(ns common.schema.entities.entity-association
  (:require
   [common.schema.associations :as associations]
   [common.schema.schema-utils :as su]))

(def import-fixed-fields
  [:entity-association/target-entity
   :entity-association/source-entity
   :entity-association/type
   :entity-association/target-comment
   :entity-association/source-comment])

;;only used for access right for now
(def schema
  (concat
   (su/option-field-multi :entity-association/category "Category" {})
   (su/text-multiline-field :entity-association/source-comment "Source comment" {:default-field-visibility :in-use})
   (su/text-multiline-field :entity-association/target-comment "Target comment" {:default-field-visibility :in-use})
   (su/keyword-field :entity-association/type "Type" nil {:default-field-visibility :in-use-disabled})
   (su/date-field :entity-association/valid-from "Valid from" {:default-field-visibility :in-use})
   (su/date-field :entity-association/valid-until "Valid until" {:default-field-visibility :in-use})
   (su/boolean-field :entity-association/former? "Former?" {})
   (su/single-ref-field :entity-association/target-entity "Target" [:entity.type/any] {})
   (su/single-ref-field :entity-association/source-entity "Source" [:entity.type/any] {})))

(def ^:private structural-association-attributes
  #{:entity-association/source-entity
    :entity-association/target-entity
    :entity-association/type})

(defn- with-structural-association-semantics
  [[attribute field-spec :as field]]
  (if (contains? structural-association-attributes attribute)
    [attribute
     (assoc field-spec
            :field/system-semantics su/user-provided-system-required-field-semantics
            :field/system-required? true)]
    field))

(defn- structural-association-schema
  [fields]
  (mapv with-structural-association-semantics fields))

;;only used for access right for now
(def deal-contact-schema
  (structural-association-schema
   [[:entity-association/source-entity
     {:field/data-type             :data.type/ref-single
      :field/mandatory             :mandatory/always
      :field/entity-types          [:entity.type/person]
      :value-type                  :entity
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Contact"}}]
    [:entity-association/target-entity
     {:field/data-type             :data.type/ref-single
      :field/mandatory             :mandatory/always
      :field/entity-types          [:entity.type/oppo]
      :value-type                  :entity
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Deal"}}]
    [:entity-association/type
     {:field/data-type             :data.type/keyword
      :field/mandatory             :mandatory/always
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :options                     (->> associations/schema
                                        :entity.type/oppo
                                        :entity.type/person
                                        (map (fn [[k a-s]]
                                               {:key   k
                                                :label (->> a-s
                                                            :translations
                                                            :en)})))

      :field/translations          {:en "Deal contact type"}}]
    [:entity-association/target-comment
     {:field/data-type             :data.type/text-multiline
      :field/default-visibility    {:editor           :editor.type/textarea
                                    :grid             :editor.type/textarea
                                    :filter           :filter.type/text
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Contact comment"}}]
    [:entity-association/source-comment
     {:field/data-type             :data.type/text-multiline
      :field/default-visibility    {:editor           :editor.type/textarea
                                    :grid             :editor.type/textarea
                                    :filter           :filter.type/text
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Deal comment"}}]]))

(def investor-contact-schema
  (structural-association-schema
   [[:entity-association/source-entity
     {:field/data-type             :data.type/ref-single
      :field/mandatory             :mandatory/always
      :field/entity-types          [:entity.type/person]
      :value-type                  :entity
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Contact"}}]
    [:entity-association/target-entity
     {:field/data-type             :data.type/ref-single
      :field/mandatory             :mandatory/always
      :field/entity-types          [:entity.type/investor]
      :value-type                  :entity
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Investor"}}]
    [:entity-association/type
     {:field/data-type             :data.type/keyword
      :field/mandatory             :mandatory/always
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :options                     (->> associations/schema
                                        :entity.type/investor
                                        :entity.type/person
                                        (map (fn [[k a-s]]
                                               {:key   k
                                                :label (->> a-s
                                                            :translations
                                                            :en)})))

      :field/translations          {:en "Investor contact type"}}]
    [:entity-association/target-comment
     {:field/data-type             :data.type/text-multiline
      :field/default-visibility    {:editor           :editor.type/textarea
                                    :grid             :editor.type/textarea
                                    :filter           :filter.type/text
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Contact comment"}}]
    [:entity-association/source-comment
     {:field/data-type             :data.type/text-multiline
      :field/default-visibility    {:editor           :editor.type/textarea
                                    :grid             :editor.type/textarea
                                    :filter           :filter.type/text
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Investor comment"}}]]))

(def froppo-contact-schema
  (structural-association-schema
   [[:entity-association/source-entity
     {:field/data-type             :data.type/ref-single
      :field/mandatory             :mandatory/always
      :field/entity-types          [:entity.type/person]
      :value-type                  :entity
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Contact"}}]
    [:entity-association/target-entity
     {:field/data-type             :data.type/ref-single
      :field/mandatory             :mandatory/always
      :field/entity-types          [:entity.type/fundraising-opportunity]
      :value-type                  :entity
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Fundraising opportunity"}}]
    [:entity-association/type
     {:field/data-type             :data.type/keyword
      :field/mandatory             :mandatory/always
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :options                     (->> associations/schema
                                        :entity.type/fundraising-opportunity
                                        :entity.type/person
                                        (map (fn [[k a-s]]
                                               {:key   k
                                                :label (->> a-s
                                                            :translations
                                                            :en)})))

      :field/translations          {:en "Fundraising opportunity contact type"}}]
    [:entity-association/target-comment
     {:field/data-type             :data.type/text-multiline
      :field/default-visibility    {:editor :editor.type/textarea
                                    :grid   :editor.type/textarea
                                    :filter :filter.type/text}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Contact comment"}}]
    [:entity-association/source-comment
     {:field/data-type             :data.type/text-multiline
      :field/default-visibility    {:editor :editor.type/textarea
                                    :grid   :editor.type/textarea
                                    :filter :filter.type/text}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Fundraising opportunity comment"}}]]))

(def holding-contact-schema
  (structural-association-schema
   [[:entity-association/source-entity
     {:field/data-type             :data.type/ref-single
      :field/mandatory             :mandatory/always
      :field/entity-types          [:entity.type/person]
      :value-type                  :entity
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Contact"}}]
    [:entity-association/target-entity
     {:field/data-type             :data.type/ref-single
      :field/mandatory             :mandatory/always
      :field/entity-types          [:entity.type/holding]
      :value-type                  :entity
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Holding"}}]
    [:entity-association/type
     {:field/data-type             :data.type/keyword
      :field/mandatory             :mandatory/always
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :options                     (->> associations/schema
                                        :entity.type/holding
                                        :entity.type/person
                                        (map (fn [[k a-s]]
                                               {:key   k
                                                :label (->> a-s
                                                            :translations
                                                            :en)})))

      :field/translations          {:en "Holding contact type"}}]
    [:entity-association/target-comment
     {:field/data-type             :data.type/text-multiline
      :field/default-visibility    {:editor :editor.type/textarea
                                    :grid   :editor.type/textarea
                                    :filter :filter.type/text}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Contact comment"}}]
    [:entity-association/source-comment
     {:field/data-type             :data.type/text-multiline
      :field/default-visibility    {:editor :editor.type/textarea
                                    :grid   :editor.type/textarea
                                    :filter :filter.type/text}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/translations          {:en "Holding comment"}}]]))

(def company-contact-schema
  (structural-association-schema
   [[:entity-association/source-entity
     {:field/data-type             :data.type/ref-single
      :field/mandatory             :mandatory/always
      :field/entity-types          [:entity.type/person]
      :value-type                  :entity
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/user}
      :field/translations          {:en "Contact"}}]
    [:entity-association/target-entity
     {:field/data-type             :data.type/ref-single
      :field/mandatory             :mandatory/always
      :field/entity-types          [:entity.type/company]
      :value-type                  :entity
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/user}
      :field/translations          {:en "Company"}}]
    [:entity-association/type
     {:field/data-type             :data.type/keyword
      :field/mandatory             :mandatory/always
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/user}
      :options                     (->> associations/schema
                                        :entity.type/company
                                        :entity.type/person
                                        (map (fn [[k a-s]]
                                               {:key   k
                                                :label (->> a-s
                                                            :translations
                                                            :en)})))
      :field/translations          {:en "Company contact type"}}]
    [:entity-association/target-comment
     {:field/data-type             :data.type/text-multiline
      :field/default-visibility    {:editor :editor.type/textarea
                                    :grid   :editor.type/textarea
                                    :filter :filter.type/text}
      :field/default-authorization {:access/read  :role/user
                                    :access/write :role/user}
      :field/translations          {:en "Contact comment"}}]
    [:entity-association/source-comment
     {:field/data-type             :data.type/text-multiline
      :field/default-visibility    {:editor :editor.type/textarea
                                    :grid   :editor.type/textarea
                                    :filter :filter.type/text}
      :field/default-authorization {:access/read  :role/user
                                    :access/write :role/user}
      :field/translations          {:en "Company comment"}}]]))

(def fof-asset-contact-schema
  (structural-association-schema
   [[:entity-association/source-entity
     {:field/data-type             :data.type/ref-single
      :field/mandatory             :mandatory/always
      :field/entity-types          [:entity.type/person]
      :value-type                  :entity
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/user}
      :field/translations          {:en "Contact"}}]
    [:entity-association/target-entity
     {:field/data-type             :data.type/ref-single
      :field/mandatory             :mandatory/always
      :field/entity-types          [:entity.type/fof-asset]
      :value-type                  :entity
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/user}
      :field/translations          {:en "Fund"}}]
    [:entity-association/type
     {:field/data-type             :data.type/keyword
      :field/mandatory             :mandatory/always
      :field/default-visibility    {:editor           :editor.type/select
                                    :grid             :editor.type/select
                                    :filter           :filter.type/select
                                    :field-visibility :in-use-disabled}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/user}
      :options                     (->> associations/schema
                                        :entity.type/company
                                        :entity.type/person
                                        (map (fn [[k a-s]]
                                               {:key   k
                                                :label (->> a-s
                                                            :translations
                                                            :en)})))
      :field/translations          {:en "Association type"}}]
    [:entity-association/target-comment
     {:field/data-type             :data.type/text-multiline
      :field/default-visibility    {:editor :editor.type/textarea
                                    :grid   :editor.type/textarea
                                    :filter :filter.type/text}
      :field/default-authorization {:access/read  :role/user
                                    :access/write :role/user}
      :field/translations          {:en "Contact comment"}}]
    [:entity-association/source-comment
     {:field/data-type             :data.type/text-multiline
      :field/default-visibility    {:editor :editor.type/textarea
                                    :grid   :editor.type/textarea
                                    :filter :filter.type/text}
      :field/default-authorization {:access/read  :role/user
                                    :access/write :role/user}
      :field/translations          {:en "Fund comment"}}]]))
